module.exports = __webpack_public_path__ + "img/financial-header-doc-2.de4db227.jpg";